import { useEffect, useState } from "react";
import { IntroTemplate } from "./Forms/IntroTemplate";
import { PersonalityTemplate } from "./Forms/PersonalityTemplate";
import { PurposeTemplate } from "./Forms/PurposeTemplate";
import { VisionTemplate } from "./Forms/VisionTemplate";
import { Schema } from "../../utils/Schema";
import { RelationshipsTemplate } from "./Forms/RelationshipsTemplate";

export const Forms = ({ forms }) => {
    const [isOpen, setIsOpen] = useState(true);
    const [introForm, setIntroForm] = useState(null);
    const [passionForm, setPassionForm] = useState(null);
    const [peopleForm, setPeopleForm] = useState(null);
    const [impactForm, setImpactForm] = useState(null);
    const [productForm, setProductForm] = useState(null);
    const [visionForm, setVisionForm] = useState(null);
    const [valuesForm, setValuesForm] = useState(null);
    const [lookForm, setLookForm] = useState(null);
    const [toneForm, setToneForm] = useState(null);
    const [attributesForm, setAttributesForm] = useState(null);
    const [competitionForm, setCompetitionForm] = useState({
        attributes: [],
        labels: [],
        datasets: [
            {
                backgroundColor: ["black", "#FCE816"],
                borderColor: ["black", "#FCE816"],
                data: [
                    {
                        x: 3,
                        y: 0,
                    },
                    {
                        x: 4,
                        y: 5,
                    },
                ],
            },
        ],
    });
    const [trendsForm, setTrendsForm] = useState(null);

    useEffect(() => {
        setIntroForm(forms?.intro ?? Schema.intro);
        setPassionForm(forms?.passion ?? Schema.purpose.passion)
        setPeopleForm(forms?.people ?? Schema.purpose.people)
        setImpactForm(forms?.impact ?? Schema.purpose.impact)
        setProductForm(forms?.product ?? Schema.purpose.product)
        setVisionForm(forms?.vision ?? Schema.vision)
        setValuesForm(forms?.values ?? Schema.personality.values)
        setLookForm(forms?.look ?? Schema.personality.look)
        setToneForm(forms?.tone ?? Schema.personality.tone)
        setAttributesForm(forms?.attributes ?? Schema.personality.attributes)
        if (forms.competition !== null) {
            setCompetitionForm(prev => ({
                ...prev,
                attributes: forms?.competition[0].attributes,
                labels: forms?.competition[0].labels,
                datasets: [
                    {
                        backgroundColor: ["black", "#FCE816"].concat(Array(forms?.competition[0].positions.length - 2).fill("red")),
                        borderColor: ["black", "#FCE816"].concat(Array(forms?.competition[0].positions.length - 2).fill("red")),
                        data: [...forms?.competition[0].positions]
                    }
                ]
            }))
        }
        setTrendsForm(forms?.trends)
    }, []);

    return (
        <section className="p-8 flex flex-col gap-3" id="answers">
            <div className="flex justify-between border-b border-dashed">
                <h2 className="text-3xl">Answers</h2>
                <button onClick={() => setIsOpen(!isOpen)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="22.828" height="12.828" viewBox="0 0 22.828 12.828">
                        <g transform="translate(-639.185 -729.386)">
                            <line x1="10" y2="10" transform="translate(650.6 730.8)" fill="none" stroke="#000" strokeLinecap="round"
                                strokeWidth="2" />
                            <line x2="10" y2="10" transform="translate(640.6 730.8)" fill="none" stroke="#000" strokeLinecap="round"
                                strokeWidth="2" />
                        </g>
                    </svg>
                </button>
            </div>
            {isOpen && (
                <article className="border-[1px] border-[black]">
                    {introForm && (<IntroTemplate introForm={introForm} />)}
                    {passionForm && peopleForm && impactForm && productForm && (
                        <PurposeTemplate
                            passionForm={passionForm}
                            peopleForm={peopleForm}
                            impactForm={impactForm}
                            productForm={productForm}
                        />)}
                    {visionForm && (
                        <VisionTemplate visionForm={visionForm} />
                    )}
                    {valuesForm && lookForm && toneForm && attributesForm && (
                        <PersonalityTemplate
                            valuesForm={valuesForm}
                            lookForm={lookForm}
                            toneForm={toneForm}
                            attributesForm={attributesForm}
                        />
                    )}
                    {competitionForm && trendsForm && (
                        <RelationshipsTemplate
                            competitionForm={competitionForm}
                            trendsForm={trendsForm}
                        />
                    )}
                </article>
            )}
        </section>
    )
}